<router-outlet></router-outlet>
<app-cookies-popup></app-cookies-popup>
<div data-cy="app-version" style="display: none;">Version: {{version}}</div>
